export const isFramed = window.parent !== window

export function getParentLocation() {
  try {
    const parentLocation = isFramed ? window.parent.location : undefined

    if (!parentLocation) {
      return
    }

    return {
      url: parentLocation.origin + parentLocation.pathname || '',
      pathname: parentLocation.pathname || ''
    }
  } catch {
    return
  }
}
